import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BreadcrumbService } from './service/breadcrumb.service';
import { Observable } from 'rxjs';
import { Breadcrumb } from './model/breadcrumb';
import { CommonModule, Location } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';

@Component({
  standalone: true,
  selector: 'markant-platform-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MarkantElementsModule, TranslocoModule, RouterLink],
})
export class BreadcrumbComponent implements OnInit {
  breadcrumbs$: Observable<Breadcrumb[]> = this.breadcrumbService.breadcrumbs$;

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly location: Location
  ) {}

  ngOnInit(): void {
    // Rebuild the breadcrumbs after page refresh
    this.breadcrumbService.buildBreadcrumb();
  }

  goBack(): void {
    this.location.back();
  }
}
